import {
  refineDeliveryDateTimeRanges,
  zodCallOffPayloadFieldsSchema,
  zodCallOffResponseSchema,
  zodCallOffStatusSchema,
} from '../validations';

// Request payload schema for updating a call-off (all fields optional)
// Extend the fields schema first, then apply date and time range refinements
export const zodUpdateCallOffPayloadSchema = refineDeliveryDateTimeRanges(
  zodCallOffPayloadFieldsSchema.extend({
    status: zodCallOffStatusSchema.nullish(),
  }),
);

// Response schema (re-export from shared)
export { zodCallOffResponseSchema as zodUpdateCallOffResponseSchema };
